<template>
  <div>
    <el-form :inline="true" :model="query" class="query-form" size="small">
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-edit"
          @click.native="handleInput(null, null)"
          >添加</el-button
        >
      </el-form-item>

      <el-form-item class="query-form-item" label="DHL">
        <el-select
          v-model="query.dhlsubareaid"
          placeholder="请选择仓库"
          style="width:150px"
          @change="onSubmit"
          clearable
        >
          <el-option
            v-for="(item, index) in listDHLSubarea"
            :key="index"
            :label="item.subareaname"
            :value="item.subareaid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="query-form-item" label="联邦物流">
        <el-select
          v-model="query.lbsubareaid"
          placeholder="请选择仓库"
          style="width:150px"
          @change="onSubmit"
          clearable
        >
          <el-option
            v-for="(item, index) in listLBSubarea"
            :key="index"
            :label="item.subareaname"
            :value="item.subareaid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="query-form-item" label="HFM">
        <el-select
          v-model="query.hfmsubareaid"
          placeholder="请选择仓库"
          style="width:150px"
          @change="onSubmit"
          clearable
        >
          <el-option
            v-for="(item, index) in listHFMSubarea"
            :key="index"
            :label="item.subareaname"
            :value="item.subareaid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="query-form-item">
        <el-input
          placeholder="国家/ID"
          v-model="query.cunsubareatest"
          prefix-icon="el-icon-search"
          @keyup.enter.native="onSubmit"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="onRest"
        ></el-button>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-download"
          size="small"
          @click="exportExcel()"
          >导出</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-download"
          @click.native="modelDownLoad"
          >下载模板</el-button
        >
        <el-upload
          class="upload-btn"
          :action="uploadAction"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleAvatarError"
          :before-upload="uploadLoadings"
          accept=".xls, .xlsx"
          multiple
        >
          <el-button size="small" type="primary" icon="el-icon-upload2"
            >导入</el-button
          >
        </el-upload>
      </el-form-item>
    </el-form>
    <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="list"
      :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column
        label="选择"
        prop="orderid"
        type="selection"
        :show-overflow-tooltip="true"
        width="50"
        align="center"
      />
      <el-table-column label="ID" align="center" prop="cunsubareauid" />
      <el-table-column
        label="国家名称( 英)"
        align="center"
        prop="countryenglishname"
      />
      <el-table-column label="国家名称(中)" align="center" prop="countryname" />
      <el-table-column label="DHL分区" align="center" prop="dhlsubareaname">
        <template slot-scope="scope">
          <span v-if="scope.row.dhlsubareaname == null">空</span>
          <span v-if="scope.row.dhlsubareaname != null">
            {{ scope.row.dhlsubareaname }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="联邦分区" align="center" prop="lbsubareaname">
        <template slot-scope="scope">
          <span v-if="scope.row.lbsubareaname == null">空</span>
          <span v-if="scope.row.lbsubareaname != null">
            {{ scope.row.lbsubareaname }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="HFM分区" align="center" prop="hfmsubareaname">
        <template slot-scope="scope">
          <span v-if="scope.row.hfmsubareaname == null">空</span>
          <span v-if="scope.row.hfmsubareaname != null">
            {{ scope.row.hfmsubareaname }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.native="handleForm(scope.$index, scope.row)"
            >修改</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click.native="handleDel(scope.row.cunsubareaid)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="left-container">
      <el-button type="danger" size="small" @click="delGroup()"
        >删除已选</el-button
      >
      <transition name="el-fade-in-linear">
        <el-button size="small" @click="toggleSelection()" v-show="cancelToggle"
          >取消选择</el-button
        >
      </transition>
    </div>
    <el-pagination
      class="pagination-container"
      background
      :current-page="query.currentPage"
      :page-size="query.pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total,sizes,prev, pager, next, jumper"
      :page-sizes="[10, 20, 30, 50]"
      :total="totalNumber"
    ></el-pagination>
    <!--导入-->

    <!--增加-->
    <el-dialog
      :visible.sync="formInput"
      :before-close="hideFormAdd"
      width="800px"
      top="5vh"
      v-dialogDrag
    >
      <el-form :model="formAdd" :rules="formRules" ref="dataForm">
        <el-form-item class="query-form-item" label="DHL">
          <el-select
            v-model="formAdd.dhlsubareaid"
            placeholder="请选择仓库"
            clearable
          >
            <el-option
              v-for="(item, index) in listDHLSubarea"
              :key="index"
              :label="item.subareaname"
              :value="item.subareaid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="query-form-item" label="联邦物流">
          <el-select
            v-model="formAdd.lbsubareaid"
            placeholder="请选择仓库"
            clearable
          >
            <el-option
              v-for="(item, index) in listLBSubarea"
              :key="index"
              :label="item.subareaname"
              :value="item.subareaid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="query-form-item" label="HFM">
          <el-select
            v-model="formAdd.hfmsubareaid"
            placeholder="请选择仓库"
            clearable
          >
            <el-option
              v-for="(item, index) in listHFMSubarea"
              :key="index"
              :label="item.subareaname"
              :value="item.subareaid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="query-form-item" label="国家" prop="countryid">
          <el-select
            v-model="formAdd.countryid"
            placeholder="请选择国家"
            clearable
          >
            <el-option
              v-for="(item, index) in listCountry"
              :key="index"
              :label="item.countryname"
              :value="item.countryid"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideFormInput">取消</el-button>
        <el-button
          type="primary"
          @click.native="formSub()"
          :loading="formLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!--修改-->
    <el-dialog
      :visible.sync="formVisible"
      :before-close="hideForm"
      width="800px"
      top="5vh"
      v-dialogDrag
    >
      <el-form :model="formData" :rules="formRules" ref="dataForm">
        <el-form-item class="query-form-item" label="DHL">
          <el-select
            v-model="formData.dhlsubareaid"
            placeholder="请选择仓库"
            clearable
          >
            <el-option
              v-for="(item, index) in listDHLSubarea"
              :key="index"
              :label="item.subareaname"
              :value="item.subareaid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="query-form-item" label="联邦物流">
          <el-select
            v-model="formData.lbsubareaid"
            placeholder="请选择仓库"
            clearable
          >
            <el-option
              v-for="(item, index) in listLBSubarea"
              :key="index"
              :label="item.subareaname"
              :value="item.subareaid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="query-form-item" label="HFM">
          <el-select
            v-model="formData.hfmsubareaid"
            placeholder="请选择仓库"
            clearable
          >
            <el-option
              v-for="(item, index) in listHFMSubarea"
              :key="index"
              :label="item.subareaname"
              :value="item.subareaid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="query-form-item" label="国家" prop="countryid">
          <el-select
            v-model="formData.countryname"
            placeholder="请选择国家"
            clearable
          >
            <el-option
              v-for="(item, index) in listCountry"
              :key="index"
              :label="item.countryname"
              :value="item.countryname"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideForm">取消</el-button>
        <el-button
          type="primary"
          @click.native="formSubmit()"
          :loading="formLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getList,
  deleteCunSubarea,
  addCunSubarea,
  getCunSubareaInfo,
  updateCunSubarea,
  getDHLSubArea,
  getLBSubArea,
  getHFMSubArea,
  getCountry,
  edit
} from "../../api/freight/cunsubarea.js";
import { BASE_URL } from "../../config/app";
const formJson = {
  cunsubareaid: "",
  cunsubareauid: "",
  countryid: "",
  dhlsubareaid: "",
  lbsubareaid: "",
  hfmsubareaid: "",
  countryname: ""
};

export default {
  data() {
    var checkCountry = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择国家"));
      } else {
        callback();
      }
    };

    return {
      cunsubareaid: "",
      cunsubareauid: "",
      countryenglishname: "",
      countryname: "",
      countryid: "",
      dhlsubareaname: "",
      lbsubareaname: "",
      hfmsubareaname: "",
      dialogVisible: false,
      cancelToggle: false,
      query: {
        cunsubareaid: "",
        dhlsubareaid: "",
        lbsubareaid: "",
        hfmsubareaid: "",
        cunsubareatest: "",
        dhlexpressid: 1,
        lbexpressid: 2,
        hfmexpressid: 3,
        currentPage: 1,
        pageSize: 10
      },
      list: [],
      totalNumber: 0,
      loading: true,
      index: null,
      formName: null,
      formLoading: false,
      formVisible: false,
      formInfo: false,
      formInput: false,
      formImport: false,
      formData: formJson,
      formAdd: formJson,
      formRules: {
        countryid: [{ validator: checkCountry, trigger: "blur" }]
      },
      multipleSelection: [], //多选集合
      listDHLSubarea: [], // DHL分区
      listLBSubarea: [], // 联邦分区
      listHFMSubarea: [], // HFM分区
      listCountry: [], // 国家
      uploadAction: BASE_URL + "/cunsubareaManage/importEx"
    };
  },
  methods: {
    //加载DHL分区
    getDHLSubArea() {
      getDHLSubArea(this.query)
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }
          this.listDHLSubarea = response.data || [];
        })
        .catch(() => {
          this.listDHLSubarea = [];
        });
    },

    //加载联邦分区
    getLBSubArea() {
      getLBSubArea(this.query)
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }
          this.listLBSubarea = response.data || [];
        })
        .catch(() => {
          this.listLBSubarea = [];
        });
    },
    //加载HFM分区
    getHFMSubArea() {
      getHFMSubArea(this.query)
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }
          this.listHFMSubarea = response.data || [];
        })
        .catch(() => {
          this.listHFMSubarea = [];
        });
    },

    //加载国家
    getCountry() {
      getCountry()
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }
          this.listCountry = response.data || [];
        })
        .catch(() => {
          this.listCountry = [];
        });
    },
    hideFormImport() {
      // 更改值
      this.formImport = !this.formImport;
      return true;
    },
    //模版下载
    modelDownLoad() {
      window.location.href = BASE_URL + "/cunsubareaManage/modelDownLoad";
    },
    uploadLoadings() {
      this.loading = true;
    },
    handleAvatarSuccess(response) {
      if (response.code) {
        this.$message.error(response.message);
        this.loading = false;
        return false;
      }
      this.$message.success("导入成功");
      this.getList();
    },
    handleAvatarError() {
      this.$message.error("上传文件出错");
      this.loading = false;
    },

    //导出
    exportExcel() {
      window.location.href = BASE_URL + "/cunsubareaManage/export";
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    dateChange(val) {
      if (val == null) {
        this.query.startTime = "";
        this.query.endTime = "";
      } else {
        this.query.startTime = val[0];
        this.query.endTime = val[1];
      }
      this.getList();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val == "") {
        this.cancelToggle = false;
        return;
      }
      this.cancelToggle = true;
    },
    delGroup() {
      var ids = this.multipleSelection.map(item => item.cunsubareaid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
      if (ids == "") {
        this.$message({
          message: "请先选择",
          type: "warning"
        });
        return;
      }
      this.handleDel(ids);
    },
    onRest() {
      this.query = {
        currentPage: 1,
        pageSize: 10
      };
      this.getList();
    },
    onSubmit() {
      this.$router.push({
        path: "",
        query: this.query
      });
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getList();
    },

    getList() {
      this.loading = true;
      getList(this.query)
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }
          this.list = response.data.list || [];
          this.totalNumber = response.data.totalNumber || 0;
          console.info(this.list.length);
          setTimeout(() => {
            this.loading = false;
          }, 0.3 * 1000);
        })
        .catch(() => {
          this.loading = false;
          this.list = [];
          this.totalNumber = 0;
        });
    },
    // 隐藏表单
    hideForm() {
      // 更改值
      this.formVisible = !this.formVisible;
      this.$refs["dataForm"].resetFields();

      return true;
    },
    hideFormAdd() {
      // 更改值
      this.formInput = !this.formInput;
      this.$refs["dataForm"].resetFields();

      return true;
    },

    hideFormInput() {
      // 更改值
      this.formInput = !this.formInput;
      this.$refs["dataForm"].resetFields();

      return true;
    },

    hideInfo() {
      // 更改值
      this.formInfo = !this.formInfo;
      // 清空表单
      this.$refs["dataForm"].resetFields();
      return true;
    },
    hideInput() {
      // 更改值
      this.formInput = !this.formInput;
      // 清空表单
      this.$refs["dataForm"].resetFields();

      return true;
    },
    // 显示表单
    handleForm(index, row) {
      this.query.cunsubareaid = row.cunsubareaid;

      this.formVisible = true;
      this.formData = Object.assign({}, formJson);
      if (row !== null) {
        this.formData = Object.assign({}, row);
      }
    },

    handleInput(index, row) {
      this.formInput = true;
      getDHLSubArea();
      getLBSubArea();
      getHFMSubArea();
      this.getCountry();
      // 清空验证信息表单
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },

    formSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          let data = Object.assign({}, this.formData);
          edit(data).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            this.$message.success("操作成功");
            // 刷新表单
            //this.$refs.tinymce.clearContent();
            this.formVisible = false;
            this.$refs["dataForm"].resetFields();
            this.getList();
          });
        }
      });
    },

    formSub() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          let data = Object.assign({}, this.formAdd);
          addCunSubarea(data).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            this.$message.success("操作成功");
            // 刷新表单
            this.$refs["dataForm"].resetFields();
            this.formInput = false;
            this.getList();
          });
        }
      });
    },
    // 删除
    handleDel(ids) {
      if (ids) {
        this.$confirm("确认要删除吗?", "提示", {
          type: "warning"
        })
          .then(() => {
            this.loading = true;
            var params = new URLSearchParams();
            params.append("ids", ids);
            deleteCunSubarea(params)
              .then(response => {
                this.loading = false;
                if (response.code) {
                  this.$message.error(response.message);
                  return false;
                }
                this.$message.success("删除成功");
                // 刷新数据
                //this.list.splice(index, 1);
                this.getList();
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      }
    }
  },
  created() {
    // 将参数拷贝进查询对象
    let query = this.$route.query;
    this.query = Object.assign(this.query, query);
    this.query.pageSize = parseInt(this.query.pageSize);
    // 加载表格数据
    this.getList();
    this.getDHLSubArea();
    this.getLBSubArea();
    this.getHFMSubArea();
    this.getCountry();
  }
};
</script>

<style type="text/scss" lang="scss">
body {
  margin: 0;
}
</style>
